import { render } from "./resetIntegrationsData.vue?vue&type=template&id=2768eee6&scoped=true"
import script from "./resetIntegrationsData.vue?vue&type=script&lang=js"
export * from "./resetIntegrationsData.vue?vue&type=script&lang=js"

import "./resetIntegrationsData.vue?vue&type=style&index=0&id=2768eee6&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2768eee6"]])

export default __exports__